export const GOOGLE_MAPS_API_KEY = 'AIzaSyDd24xwVbCf6n7gANrAVZXmnWntIQZN_pI';

// https://cse.google.com/cse/all
export const GOOGLE_CUSTOM_SEARCH_API_KEY_PRODUCT = 'AIzaSyCXEENiTSTMOtR5t3dzId1fwOQvClSEOio';
export const GOOGLE_CUSTOM_SEARCH_CX_PRODUCT = '007168514042970860269:h2khl651dk0';
// shellen's?
// public key = 'AIzaSyCXEENiTSTMOtR5t3dzId1fwOQvClSEOio';
// public cx = '001237309184032556999:o1qhpx_gryw';

export const GOOGLE_CUSTOM_SEARCH_API_KEY_MEDIA = 'AIzaSyCXEENiTSTMOtR5t3dzId1fwOQvClSEOio';
export const GOOGLE_CUSTOM_SEARCH_CX_MEDIA = '001237309184032556999:7fnxeakah3s';

// TODO: Make sure you configure the `algolia.app_id` and `algolia.api_key` Google Cloud environment variables.
// could this work???
export const ALGOLIA_ID = 'JW4UYOGMVU';
export const ALGOLIA_SEARCH_KEY = '6c7666ecfd29f2d319cd9ef89f791c92';

export const GENIUS_TS_ID = '84328';

export const IFRAMELY_API_KEY='e43939f49f84f3143a84d9';